import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import { CONTENT } from '../content';

export default function Legal() {
  const { language } = useLanguage();
  const t = CONTENT[language].legal;
  const { search } = useLocation();
  
  useEffect(() => {
    const params = new URLSearchParams(search);
    const section = params.get('section');
    if (section) {
      const el = document.getElementById(section);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
        window.scrollTo(0,0);
    }
  }, [search]);

  return (
    <div className="bg-suncoast-offWhite min-h-screen py-16">
      <div className="container mx-auto px-4 lg:px-12 max-w-4xl">
        <h1 className="text-4xl font-bold text-suncoast-dark mb-12 text-center">{t.title}</h1>
        
        <div className="space-y-12">
            
            {/* Terms */}
            <section id="terms" className="bg-white p-8 rounded-xl shadow-sm">
                <h2 className="text-2xl font-bold text-suncoast-primary mb-4">{t.sections.terms.title}</h2>
                <div className="space-y-3 text-gray-700 leading-relaxed">
                    {t.sections.terms.content.map((p, i) => (
                        <p key={i}>{p}</p>
                    ))}
                </div>
            </section>

            {/* Privacy */}
            <section id="privacy" className="bg-white p-8 rounded-xl shadow-sm">
                <h2 className="text-2xl font-bold text-suncoast-primary mb-4">{t.sections.privacy.title}</h2>
                 <div className="space-y-3 text-gray-700 leading-relaxed">
                    {t.sections.privacy.content.map((p, i) => (
                        <p key={i}>{p}</p>
                    ))}
                </div>
            </section>

            {/* Security */}
             <section id="security" className="bg-white p-8 rounded-xl shadow-sm">
                <h2 className="text-2xl font-bold text-suncoast-primary mb-4">{t.sections.security.title}</h2>
                 <div className="space-y-3 text-gray-700 leading-relaxed">
                    {t.sections.security.content.map((p, i) => (
                        <p key={i}>{p}</p>
                    ))}
                </div>
            </section>

             {/* Cookies */}
             <section id="cookies" className="bg-white p-8 rounded-xl shadow-sm">
                <h2 className="text-2xl font-bold text-suncoast-primary mb-4">{t.sections.cookies.title}</h2>
                 <div className="space-y-3 text-gray-700 leading-relaxed">
                    {t.sections.cookies.content.map((p, i) => (
                        <p key={i}>{p}</p>
                    ))}
                </div>
            </section>

             {/* Do Not Share */}
             <section id="donotshare" className="bg-white p-8 rounded-xl shadow-sm border-2 border-suncoast-secondary/20">
                <h2 className="text-2xl font-bold text-suncoast-primary mb-4">{t.sections.doNotShare.title}</h2>
                 <div className="space-y-3 text-gray-700 leading-relaxed">
                    {t.sections.doNotShare.content.map((p, i) => (
                        <p key={i}>{p}</p>
                    ))}
                </div>
            </section>

        </div>
      </div>
    </div>
  );
}